export default __webpack_public_path__ + "33161f3bfe9a765f32a640027d0b075f.svg";